import React, { PureComponent } from "react";
import { IonButton, IonImg, isPlatform, IonRow, IonCol } from "@ionic/react";
import { R2Configuration } from "../../utils/common";
import { ICON_PATH } from '../../utils/constants';
import { FormatText } from '../Menu/FormatTextComponent/formatText';

interface ErrorProps {
  constantText: any;
  loads?: any;
  constantButton: any;
  addCapacity?: any;
  redirectTo?: any;
  constCapacityButton?: any;
  orText?: any;
}
export class RecommendedError extends PureComponent<ErrorProps, any> {
  render() {
    return (
      <div className="No-Recommended" data-testid="recommendederror"> 
        <img
          alt="logo"
          src="assets/icon/no-search-icon.svg"
          width="79.01px"
          height="84.59px"
        />
        <div className="recommended-Error">
          <FormatText
            text={this.props.constantText}
            dataType={'richText'}
          />
        </div>
        {isPlatform("desktop") ? (
          <IonRow>
            <IonCol size="6">
              <div className="SearchLoadBtn">
                <IonButton
                  expand="full"
                  shape="round"
                  onClick={this.props.loads}
                  size="large"
                  type="submit"
                  class="RecommendedSearch"
                >
                  <IonImg
                    src={ICON_PATH.search_error}
                    class="load-search"
                  />
                  {this.props.constantButton}
                </IonButton>
              </div>
            </IonCol>
            {this.props.addCapacity && !R2Configuration.details.getR2FeatureEnable() ? (
              <>
                <IonCol size="6">
                  <div className="SearchLoadBtn">
                    <IonButton
                      expand="full"
                      shape="round"
                      onClick={this.props.addCapacity}
                      size="large"
                      type="submit"
                      class="RecommendedSearch"
                    >
                      <IonImg
                        src={ICON_PATH.add_capacity}
                        class="load-search"
                      />
                      {this.props.constCapacityButton}
                    </IonButton>
                  </div>
                </IonCol>
              </>
            ) : null}
          </IonRow>
        ) : (
          <>
            <div className="SearchLoadBtn">
              <IonButton
                expand="full"
                shape="round"
                onClick={this.props.loads}
                size="large"
                type="submit"
                class="RecommendedSearch"
              >
                <IonImg src={ICON_PATH.search_error} class="load-search" />
                {this.props.constantButton}
              </IonButton>
            </div>
            {this.props.addCapacity && !R2Configuration.details.getR2FeatureEnable() ? (
              <>
                <div className="recommended-error-btn-p">{this.props.orText}</div>

                <div>
                  <IonButton
                    expand="full"
                    shape="round"
                    onClick={this.props.addCapacity}
                    size="large"
                    type="submit"
                    class="RecommendedSearch"
                  >
                    <IonImg
                      src={ICON_PATH.add_capacity}
                      class="load-search"
                    />
                    {this.props.constCapacityButton}
                  </IonButton>
                </div>
              </>
            ) : null}
          </>
        )}
      </div>
    );
  }
}
